import { Consignment, ConsignmentService, FetchConsignmentsRequestParam, ProposalHistoryResponse } from '../../../Services/consignment.service';
import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem } from 'primeng/api';
import { ArtistsService } from '../../../Services/artists.service';
import { AuthConfig, AuthService, } from '../../../Services/auth.service';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import { ConnectedGallery, ConnectionsService } from 'src/app/Services/connections.service';
import { ImageUrls, NotificationTypes } from 'src/app/app.enums';
import { CategoryService } from 'src/app/Services/category.service';
import { MessagingService } from 'src/app/Services/messaging.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { GalleriesService, GalleryItems } from 'src/app/Services/galleries.service';
import { ImageUtils } from 'src/app/shared/utils/image-utils';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'view-consignment',
    templateUrl: './view-consignments.component.html',
    // templateUrl: './view-consignments.v2.component.html',
    providers: [CategoryService, ConsignmentService, ConnectionsService],
    standalone: false
})
export class ViewConsignmentsComponent implements OnInit {
  public artistId!: string | null;
  public consignments: Consignment[] = [];
  public consignment: Consignment;
  public artists: SelectItem[] = [];
  public authConfig: AuthConfig = {};
  public galleryLabel: SelectItem[] = [];
  public defaultImageUrl: string = ImageUrls.IMAGE1;
  public consignmentProductsDialogVisible: boolean = false;
  public selectedConsignment: Consignment | null = null;
  public consignmentProducts: ArtistProduct[] = [];
  public productMiniDialogVisible: boolean = false;
  public selectedArtworkProduct: ArtistProduct | null = null;
  public consignmentStatusItems: SelectItem[] = [];
  public connectedGalleryItems: SelectItem[] = [];
  public filters: FetchConsignmentsRequestParam = {};
  public searchText: string = ''; // Property to store the search query
  public filteredProducts: ArtistProduct[] = []; // Property to store filtered products
  public showProposalHistory: boolean = false;
  public consignmentId!: string;
  public addConsignmentDialogVisible: boolean = false;
  public newConsignment: Partial<Consignment> = {}; // Holds the new consignment data
  public statusItem = ['Pending', 'Catalogue', 'Delivery', 'Sales'];
  public commissionOptions: { value: number; label: string }[] = [];
  public artistConnectedGalleries: SelectItem[] = [];
  public selectedInventory: ArtistProduct[] = [];
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private ngxSpinnerService: NgxSpinnerService,
    private artistService: ArtistsService,
    private messagingService: MessagingService,
    private consignmentService: ConsignmentService,
    private notificationsService: NotificationsService,
    private galleriesService: GalleriesService,

    private connectionsService: ConnectionsService,
    private transloco: TranslocoService) {
    this.consignment = new Consignment();
  }

  public ngOnInit(): void {
    this.authConfig = this.authService.getAuthConfig();
    //try to find the consignment id which will be in the route when updating
    this.activatedRoute.params.subscribe((params) => {
      if (params['artistId']) {
        //incase, the logged-in user is an administrator, we also pass the artist id in the route
        this.artistId = this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator ? params['artistId'] : null;
      }
      this.consignment = new Consignment();
      this.consignment.ConsignmentStatus = 'Delivery';
      this.consignment.GallerySaleType = 'Consignment';
    });

    //if the logged-in user is an artist, set his Id from the token
    if (this.authConfig.IsArtist) {
      this.artistId = this.authService.getUserId();
    }
    //if we don't have a ConsignmentId incase of a "New Consignment", and the logged-in user is an administrator, we won't have an artist id yet,
    //so don't call the initialize inventory in that case
    if (!this.consignmentId && this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {

    } else {
      //get all the galleries that are connected to this artist
      //initialize the currently available and selected inventory lists for this artist
    }

    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
      //only fetch all the artists incase the logged-in user is an administrator
      this.getAllArtists();
    }

    // Generate options from 5% to 90% with a step of 5%
    for (let i = 5; i <= 90; i += 5) {
      this.commissionOptions.push({ value: i, label: `${i}%` });
    }

    this.authConfig = this.authService.getAuthConfig();
    this.activatedRoute.params.subscribe((params) => {
      if (this.authConfig.IsArtist && params['galleryId']) {
        //artist is trying to filter the consignments by the gallery 
        this.filters.GalleryId = params['galleryId'];
      }
    });

    //get all the consignments (of logged-in user)
    this.getConsignments(this.filters);

    if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator || this.authConfig.IsGallery) {
      //only fetch all the artists if the logged-in user is an administrator or a gallery (in which case, only their connected artists will be returned)
      this.getConnectedArtists();
    }

    if (this.authConfig.IsArtist) {
      //for artists, fetch their connected galleries so we can allow them to filter the consignments using the galleries
      var includeInvitedGalleries = false;
      this.getConnectedGalleries(this.authService.getUserId(), includeInvitedGalleries);
    }

    this.consignmentStatusItems = [];

    if (!this.authConfig.IsGallery) {
      // Set default status and show it as a placeholder for administrator and artists
      this.consignmentStatusItems.push({ label: 'Filter By Consignment Status', value: 'Filter By Consignment Status' });
      this.consignmentStatusItems.push({ label: 'Draft', value: 'Draft' });
    } else {
      // For galleries, show placeholder without default status
      this.consignmentStatusItems.push({ label: 'Filter By Consignment Status', value: null });
    }
    // Add other status options
    this.consignmentStatusItems.push({ label: 'Dispatched', value: 'WaitingForGalleryApproval' });
    this.consignmentStatusItems.push({ label: 'Accepted', value: 'Accepted' });
  }

  public reciveNotifications() {
    this.messagingService.currentMessage.subscribe((data: any) => {
      this.messagingService.handleNotificationRead(data.data.entityId);
    });
  }


  public onDropdownClick(): void {
    // Remove the default placeholder item when the dropdown is clicked
    if (this.authConfig.IsArtist) {
      const defaultPlaceholderIndex = this.consignmentStatusItems.findIndex(item => item.value === 'Filter By Consignment Status');
      if (defaultPlaceholderIndex !== -1) {
        this.consignmentStatusItems.splice(defaultPlaceholderIndex, 1);
      }
    } else {
      const defaultPlaceholderIndex = this.consignmentStatusItems.findIndex(item => item.value === null);
      if (defaultPlaceholderIndex !== -1) {
        this.consignmentStatusItems.splice(defaultPlaceholderIndex, 1);
      }
    }
  }


  private getConsignments(filters: FetchConsignmentsRequestParam) {
    this.ngxSpinnerService.show();
    this.consignmentService.getConsignments(filters).subscribe((consignments) => {
      this.consignments = consignments;
      console.log(this.consignments);
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  private getConnectedArtists() {
    this.artists = [];
    this.artistService.getArtistsDropdownData().subscribe((artists) => {
      this.artists = artists;
    }, (error) => { console.error(error); });
  }

  private getConnectedGalleries(artistId: string, includeInvited: boolean) {
    this.connectedGalleryItems = [];
    this.connectionsService.getConnectedGalleries(artistId, includeInvited).subscribe((galleries) => {
      this.connectedGalleryItems = galleries.map((gallery) => { return { label: gallery.Name, value: gallery.Id } });
    }, (error) => { console.error(error); });
  }


  // update Consignment 
  public navigateToConsignment(rowData: Consignment) {
    if (this.authConfig.IsAdministrator || this.authConfig.IsSuperAdmin) {      //if the logged-in user is an administrator, he should pass-in the selected artist id
      this.router.navigate(['/artists', rowData.ArtistId, 'consignments', rowData.Guid, 'view']);
    } else if (this.authService.isArtist()) {
      //if the logged-in user is an artist
      this.router.navigate(['/artists', 'consignments', rowData.Guid, 'view']);
    }
  }

  public openViewConsignmentProductsDialog(rowData: Consignment) {
    this.selectedConsignment = rowData;
    this.getConsignmentProducts(this.selectedConsignment.Guid);
    this.consignmentProductsDialogVisible = true;
  }

  public getConsignmentProducts(consignmentId: string) {
    //get the consignment products
    this.consignmentProducts = [];
    this.ngxSpinnerService.show();
    this.consignmentService.getConsignmentProducts(consignmentId).subscribe((consignmentProducts) => {
      //set the category name against each product
      this.consignmentProducts = consignmentProducts;
      this.consignmentProducts = consignmentProducts.map((product) => {
        product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.ProductImgUrl || 'assets/images/No-Image.png');
        return product;
      });
      //console.log(this.consignmentProducts);
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public showProductDetailsDialog(artistProduct: ArtistProduct) {
    this.selectedArtworkProduct = artistProduct;
    this.productMiniDialogVisible = true;
    // Update the ProductImgUrl property of selectedArtworkProduct
    this.selectedArtworkProduct.ProductImgUrl = this.selectedArtworkProduct.ProductImgUrl || this.defaultImageUrl;
  }


  public onProductMiniDialogClosed($event: any) {
    this.productMiniDialogVisible = false;
    this.selectedArtworkProduct = null;
  }


  public onGalleriesChanged($event: SelectItem) {
    this.filters.GalleryId = $event.value;
    this.getConsignments(this.filters);
  }



  public reviewConsignmentProducts(rowData: Consignment) {
    this.router.navigate(['/consignment', rowData.Guid, 'consignment-product-selection']);
  }

  public generatePdf(rowData: Consignment) {
    this.ngxSpinnerService.show();
    this.consignmentService.generatePDF(rowData.Guid).subscribe((response: Blob) => {
      var fileName = rowData.Name + '-' + (new Date().getTime()) + '.pdf';
      //save the file on user's system
      saveAs(new Blob([response], { type: 'application/pdf' }), fileName);
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public goToProductDetails(product: ArtistProduct) {
    this.router.navigate(['/', product.ArtistId, 'artworks', product.Id]);
  }

  isToday(date: Date): boolean {
    const today = new Date();
    const providedDate = new Date(date);
    return providedDate.getFullYear() === today.getFullYear() && providedDate.getMonth() === today.getMonth() && providedDate.getDate() === today.getDate();
  }

  dispatchedDaysAgo(date: Date): number {
    const currentDate = new Date();
    const dispatchedDate = new Date(date);
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const daysAgo = Math.round(Math.abs((currentDate.getTime() - dispatchedDate.getTime()) / oneDay));
    return daysAgo;
  }

  public addConsignment() {
    // this.router.navigate(['/artists', 'add-consignment']);
    this.addConsignmentDialogVisible = true;
     this.getAllGalleries(this.artistId ?? "");

  }

  // Close the Add Consignment dialog
  public closeAddConsignmentDialog(): void {
    this.addConsignmentDialogVisible = false;
  }
    public selectedGalleryDetails: GalleryItems | null = null; 


  public onGalleryChanged($event: any) {
    const galleryId = $event.value;
    this.getGalleryById(galleryId, (gallery: GalleryItems) => {
      if (gallery) {
                this.selectedGalleryDetails = gallery; // Store the selected gallery details
        this.consignment.SalesTaxPercentage = gallery.SalesTaxPercentage ?? 0; // Set sales tax from gallery

        // Reset the sale type to "Consignment" by default
        this.consignment.GallerySaleType = 'Consignment';
        // Update other parameters from the gallery
        this.consignment.Commission = gallery.CommissionPercentage;
        const selectedGallery = this.artistConnectedGalleries.find(
          g => g.value === galleryId
        );
  
        const currentDate = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        const formattedDate = `${pad(currentDate.getDate())}-${pad(currentDate.getMonth() + 1)}-${currentDate.getFullYear()}`;
  
        if (selectedGallery) {
          this.consignment.Name = `${selectedGallery.label}-${formattedDate}`;
        }
      }
    });
  }
  public getGalleryById(galleryId: string, callback: Function) {
    this.ngxSpinnerService.show();
    this.galleriesService.fetchById(galleryId).subscribe((gallery) => {
      this.ngxSpinnerService.hide();
      callback(gallery);
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  // Save the new consignment
  public saveConsignment($event: any) {
    this.consignment.SelectedProductIds = this.selectedInventory.map(p => p.Id);

    if (this.authConfig.IsArtist) {
      this.consignment.ArtistId = this.authService.getUserId();
    } else if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
      this.consignment.ArtistId = this.artistId || '';
    }

    if (!this.consignment.Guid) {
      this.ngxSpinnerService.show();
      this.consignmentService.createConsignment(this.artistId ?? '', this.consignment.GalleryId ?? '', {
        Name: this.consignment.Name,
        ConsignmentStatus: this.consignment.ConsignmentStatus,
        GallerySaleType: this.consignment.GallerySaleType,
      SalesTaxPercentage: this.consignment.SalesTaxPercentage, 
        Commission: this.consignment.Commission,
        SelectedProductIds: this.consignment.SelectedProductIds
      }).subscribe((response) => {
        this.ngxSpinnerService.hide();
        if (response.Success && response.ResponseData) {
          var consignmentId = response.ResponseData;
          // IF THE LOGIN USER IS ADMINISTRATOR
          if (this.authConfig.IsSuperAdmin || this.authConfig.IsAdministrator) {
            this.router.navigate(['artists', this.consignment.ArtistId, 'consignments', consignmentId, 'view'])
          }
          if (this.authConfig.IsArtist) {
            //redirect the user to the newly created consignment
            this.router.navigate(['artists', 'consignments', consignmentId, 'view']);
          }
          this.notificationsService.showNotification(this.transloco.translate('viewConsignments.success'), this.transloco.translate('viewConsignments.consignmentCreatedSuccessfully'), NotificationTypes.Success);

        } else {
          console.error(response);
          this.notificationsService.showNotification(this.transloco.translate('viewConsignments.error'), this.transloco.translate('viewConsignments.errorSavingConsignment'), NotificationTypes.Error);
        }
      }, (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      });
      this.closeAddConsignmentDialog();
    }
  }
  
  public onConsignmentStatusChanged($event: any) {
    if ($event.value === null) {
      // Clear the filter and refresh data
      this.filters.Status = undefined;
    } else {
      this.filters.Status = $event.value;
    }
    this.getConsignments(this.filters);
  }

  private getAllGalleries(artistId: string) {
    this.ngxSpinnerService.show();
    this.connectionsService.getConnectedGalleries(artistId, false).subscribe((galleries: ConnectedGallery[]) => {
      this.artistConnectedGalleries = galleries.map((gallery) => ({ label: gallery.Name, value: gallery.Id }));
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public onArtistChanged($selectedArtistId: string) {
    this.artistId = $selectedArtistId;
    //since the artist has changed, reinitialize his current products
    this.getAllGalleries(this.artistId)
  }
  public onArtistChange($event: any) {
    this.filters.ArtistId = $event.value; // Get the artist ID from the event, assuming the event has the artist ID
    this.getConsignments(this.filters);
  }

  private getAllArtists() {
    this.artistService.getArtistsDropdownData().subscribe((artists) => {
      this.artists = artists;
    }, (error) => { console.error(error); });
  }

  public getNamePlaceholder(): string {
    const selectedGallery = this.artistConnectedGalleries.find(gallery => gallery.value === this.consignment.GalleryId);
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`; // Format: DD-MM-YYYY
    return selectedGallery ? `${selectedGallery.label}-${formattedDate}` : 'Enter Name';
  } 
  
}